import { Locale, type LocalizedString } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/dekujeme-za-clenstvi" as const,
	[Locale.en]: "/thank-you-for-membership" as const,
} satisfies LocalizedString;

export function getSubscriptionThankYouPath(locale: Locale): string {
	return getPathInLocale(locale, pathMap);
}
